import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PasswordPolicyRule {
  id: string;
  value?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  private readonly baseUrl = environment.BASE_API_URL;

  constructor(private readonly http: HttpClient) {}

  changePassword(
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
  ): Observable<any> {
    return this.http.put(`${this.baseUrl}user/account/change-password`, {
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword
    });
  }

  getPasswordPolicy(): Observable<PasswordPolicyRule[]> {
    return this.http.get<PasswordPolicyRule[]>(
      `${this.baseUrl}user/account/password-policy`
    );
  }
}
